import { CircleAppLinks } from "@/react/components/CommunityOnboarding/NewChecklistComponents/CircleAppLinks";
import { Resources } from "@/react/components/CommunityOnboarding/NewChecklistComponents/Resources";
import { usePunditUserContext } from "@/react/contexts";
import { Typography } from "@circle-react-uikit/Typography";
import { t } from "@/i18n-js/instance";

export const AdminDashboardPage = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const firstName = currentCommunityMember?.name;

  return (
    <div className="mx-auto max-w-4xl px-6 py-8">
      <div className="mb-8">
        <Typography.TitleLg weight="bold">
          {t("admin_dashboard.greeting", { firstName })}
        </Typography.TitleLg>
      </div>
      <div className="mb-10">
        <Resources variant="admin-dashboard" />
      </div>
      <CircleAppLinks />
    </div>
  );
};
